import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GlobalVariable } from '../globals';

@Injectable({
  providedIn: 'root'
})
export class GarageDetailsService {

  constructor(private http: HttpClient) {}

  getCoupons(key: string): Observable<any> {
    // const url = `${GlobalVariable.BASE_API_URL}` + '/couponredeem/v1/getCouponCode/'+key+'?t='+Date.now();
    const url = `${GlobalVariable.BASE_API_URL}` + '/couponredeem/v1/getCouponCode/'+key;
    return this.http.get<any>(url);
  }


  getGarageDetails(key: string): Observable<any> {
    const url = `${GlobalVariable.BASE_API_URL}` + '/garage/website/'+key;
    return this.http.get<any>(url);
  }

  createBooking(payload: any): Observable<any> {
    const url = `${GlobalVariable.BASE_API_URL}` + '/booking/v1/create';
    return this.http.post<any>(url, payload);
  }

    getCategoriesAndSubCategories(): Observable<any> {
    return this.http.get(`${GlobalVariable.BASE_API_URL}` + '/api/v1/service/getCategoriesAndSubCategories');
  }

}
